export default __webpack_public_path__ + "static/media/Icon1.244e8697.svg";